import { trackPromise } from 'react-promise-tracker';

import { setTimeline, setMetrics } from './timeline-view-slice';
import { areas } from 'constants/constants';
import {
  setEngagements,
  setIsLoading,
  setPagination,
} from '../engagement/engagement-slice';
import api from 'api';

export const getEngagementTimelineAndPills = (expression) => {
  return async (dispatch) => {
    try {
      dispatch(setMetrics([]));
      trackPromise(
        api
          .get('qlik/engagement-timeline', {
            params: {
              expression: expression,
            },
            headers: {
              qlikCookie: localStorage.getItem('qlikCookie'),
              Authorization: `Bearer ${localStorage.getItem('qlikToken')}`,
            },
          })
          .then((response) => {
            dispatch(setMetrics(response?.data?.pills));
            dispatch(setTimeline(response?.data?.timeline));
          }),
        areas.timeline
      );
    } catch (error) {
      console.error('Error fetching engagement timeline and pills:', error);
    }
  };
};

export const getEngagementDetails = (
  filterExpression,
  offset = 0,
  sortBy = 'Date',
  order = 'DESC',
  limit = 5
) => {
  return async (dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response = await api.get('qlik/engagement-table', {
        params: {
          filterExpression,
          offset,
          limit,
          order,
          sortBy,
        },
        headers: {
          qlikCookie: localStorage.getItem('qlikCookie'),
          Authorization: `Bearer ${localStorage.getItem('qlikToken')}`,
        },
      });
      dispatch(setEngagements(response?.data));
      dispatch(
        setPagination({
          total: response?.data?.totalSize,
          currentListSize: response?.data?.currentListSize,
          offset: response?.data?.offset,
          hasMoreElement: response?.data?.hasMoreElement,
        })
      );
      dispatch(setIsLoading(false));
    } catch (error) {
      dispatch(setIsLoading(false));
      console.error('Error fetching engagement details:', error);
    }
  };
};
